import { useContext } from "react";
import { AuthContext } from "../../../context/context.authentication";

const CurrentUser = ({
  children,
}: {
  children: (userId: string) => React.ReactNode;
}) => {
  const { auth } = useContext(AuthContext);
  if (!auth.ok) {
    return null;
  }
  return children(auth.sub);
};
export default CurrentUser;
